module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/logo-aoj-zh-hant-97ce8c10cdbb29b0c3dd9c694da0c9ff.svg";